export default __webpack_public_path__ + "static/b-user-testing-screen-3-c4b42bf3f91f0b4a164eeb5d09bac095.jpg";